module.exports = __webpack_public_path__ + "assets/fonts/d40bef22-cb80-4836-a2ea-54babd2aac8a.4f483e1d.ttf";